import React, { CSSProperties, FC } from 'react';

import { IconButton, Menu } from '@atom/mui';
import colors from '@atom/styles/colors';

import { useAskApproachAction } from './hooks/useAskApproachAction';
import { useCopyAction } from './hooks/useCopyAction';
import { useExportDatasetAction } from './hooks/useExportDatasetAction';
import { useFeedbackAction } from './hooks/useFeedbackAction';
import { useShowQueryAction } from './hooks/useShowQueryAction';
import { styles as commonStyles } from './styles';
import { ChatAssistantMessageHookResponse } from './types';

import classes from '../chat.module.css';

const styles: Record<string, CSSProperties> = {
  iconButton: {
    height: '1.5rem',
    width: '1.5rem',
  },
  ...commonStyles,
};

const ChatAssistantMessageFooter: FC = () => {
  // composable hook pattern makes it easier to abstract custom logic to each menu option
  const actions: ChatAssistantMessageHookResponse[] = [
    useCopyAction(),
    useFeedbackAction(),
    useShowQueryAction(),
    useAskApproachAction(),
    useExportDatasetAction(),
  ];

  const standaloneActions = actions.filter(
    action => action.available && action.type === 'standalone',
  );

  const menuActions = actions.filter(
    action => action.available && action.type === 'menu',
  );

  return (
    <>
      <div className={classes.feedbackContainer}>
        {standaloneActions.map(action =>
          action.ui.map(({ icon, copy, onClick }, index) => (
            <IconButton
              key={index}
              style={styles.iconButton}
              onClick={onClick}
              tooltip={copy}
            >
              {icon}
            </IconButton>
          )),
        )}
        {menuActions.length > 0 && (
          <Menu
            IconButtonProps={{
              style: styles.iconButton,
            }}
            IconProps={{
              color: colors.neutral.gray,
            }}
          >
            {menuActions.map(action =>
              action.ui.map(({ icon, copy, onClick }, index) => (
                <Menu.MenuItem key={index} onClick={onClick}>
                  {icon}
                  {copy}
                </Menu.MenuItem>
              )),
            )}
          </Menu>
        )}
      </div>
      {actions.map((action, index) =>
        action.content ? (
          <React.Fragment key={index}>{action.content}</React.Fragment>
        ) : null,
      )}
    </>
  );
};

export default ChatAssistantMessageFooter;
